/* Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved. */

export const profilePages = {
    ActivityFeedPage: () => import('@/profile/ActivityFeedPage'),
    ProfileDetailPage: () => import('@/profile/ProfileDetailPage'),
    ProfileSetupPage: () => import('@/profile/ProfileSetupPage'),
    ProfilesPage: () => import('@/profile/ProfilesPage'),
    PublicPlaylistsPage: () => import('@/playlistdetail/PublicPlaylistsPage'),
    SelectProfilePage: () => import('@/profile/SelectProfilePage'),
    SuggestedProfilesPage: () => import('@/profile/SuggestedProfilesPage'),
    UserFollowsPage: () => import('@/profile/UserFollowsPage'),
}
